<template>
  <div>
    <el-row>
      <el-col :span="2" :offset="6">
        <div style="font-size:20px">Device {{device.humanReadableCode}}</div>
      </el-col>
      <el-col :span="3" :offset="8">
        <el-button v-if="cards.length>0 && $store.getters.isAdmin" type="danger" @click="removeCards()">Remove Cards</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" :offset="6">
        <el-table :data="cards" empty-text="No active cards">
          <el-table-column prop="cardNumber" label="Card"/>
          <el-table-column prop="cardType" label="Type"/>
          <el-table-column prop="expirationDate" label="Expires"/>
          <el-table-column prop="firstName" label="First Name"/>
          <el-table-column prop="lastName" label="Last Name"/>
          <el-table-column prop="phone" label="Phone"/>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { Promise } from "q";

export default {
  name: "Device",
  props: ["id"],
  data() {
    return {
      device: {
        code: null,
        humanReadableCode: null
      },
      cards: []
    };
  },

  computed: {},

  created() {
    let devUrl = `${process.env.VUE_APP_API}devices/${this.id}`;
    let cardsUrl = `${process.env.VUE_APP_API}devices/${this.id}/credit-cards`;
    let devPromise = axios.get(devUrl, {
      headers: {
        authorization: window.sessionStorage.getItem("token")
      }
    });
    let cardsPromise = axios.get(cardsUrl, {
      headers: {
        authorization: window.sessionStorage.getItem("token")
      }
    });
    Promise.all([devPromise, cardsPromise]).then(results => {
      this.device = results[0].data;
      this.cards = results[1].data;
    });
  },

  methods: {
    rowStatus({ row, _ }) {
      if (row.isRemoved) return "disabled-row";
      return ";";
    },

    removeCards() {
      this.$confirm(
        "This will permanently remove active cards. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          let cardsUrl = `${process.env.VUE_APP_API}devices/${
            this.id
          }/credit-cards`;
          axios
            .delete(cardsUrl, {
              headers: {
                authorization: window.sessionStorage.getItem("token")
              }
            })
            .then(result => {
              this.cards = [];
              this.$message({
                type: "success",
                message: "Remove completed"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Remove canceled"
          });
        });
    },
  }
};
</script>
